/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Destination, Destination$inboundSchema } from "./destination.js";

export type ListDestinationsResult = {
  /**
   * Active data export destinations in the selected project.
   */
  destinations: Array<Destination>;
};

/** @internal */
export const ListDestinationsResult$inboundSchema: z.ZodMiniType<
  ListDestinationsResult,
  unknown
> = z.object({
  destinations: z.array(Destination$inboundSchema),
});

export function listDestinationsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDestinationsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDestinationsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDestinationsResult' from JSON`,
  );
}
